import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { Encounter } from "@curai/js-fhir-tools";

/** Caller-tunable query options for {@link useEncounter} (e.g. polling). */
type UseEncounterOptions = {
  /** Poll interval in ms (or `false` to disable). Forwarded to React Query. */
  refetchInterval?: number | false;
};

/**
 * Hook for fetching ONLY an encounter resource by encounter ID.
 *
 * This is used by EncounterStartMessage to retrieve the latest RFE information.
 *
 * @param encounterId - The ID of the encounter to fetch
 * @param options - Optional query options (e.g. `refetchInterval` for polling)
 * @returns The encounter
 */
export const useEncounter = (
  encounterId?: string,
  patientId?: string,
  options?: UseEncounterOptions,
) => {
  return useApi<Encounter>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get(
          `/fhir/Encounter/${encounterId}`,
        );
        return new Encounter(response.data);
      },
      queryKey: QueryKeys.Patient.Chat.Encounter.DEFAULT(
        patientId,
        encounterId,
      ),
      enabled: Boolean(encounterId),
      ...options,
    },
  });
};
